export default {
    baseStyle: {
        heading: {
            lineHeight: '24px',
            minHeight: '56px',
            padding: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        closeButton: {
            cursor: 'pointer'
        },
        leftArrowButton: {
            padding: 0,
            height: 'auto',
            minWidth: 'auto',
            _hover: {
                backgroundColor: 'white'
            }
        },
        stickyHeader: {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            backgroundColor: 'white',
            width: '100%'
        },
        catHeading: {
            fontSize: '20px',
            lineHeight: '1.2',
            letterSpacing: '0px',
            textTransform: 'uppercase',
            fontWeight: 'bold'
        },
        carouselImage: {
            width: '100%',
            height: 'auto'
        },
        swiperContainer: {
            marginTop: 14,
            marginLeft: '16px'
        },
        swiperTitle: {
            fontSize: 'md',
            fontWeight: 'bold',
            lineHeight: '100%',
            letterSpacing: '0px',
            marginBottom: 3,
            textTransform: 'uppercase'
        },
        slideTitle: {
            fontSize: 'sm',
            lineHeight: '18px',
            letterSpacing: '0px',
            fontWeight: 'medium',
            marginTop: 2
        },
        priceStyle: {
            fontWeight: 'medium'
        },
        navDivider: {
            borderColor: 'grey.400',
            marginTop: '52px',
            marginBottom: '52px',
            marginLeft: 4
        },
        navFooterButton: {
            marginLeft: 4,
            marginRight: 4,
            marginBottom: 4,
            height: 'auto',
            width: 'auto',
            display: 'inline-block'
        },
        navFooterLinkContainer: {
            alignItems: 'center'
        },
        navFooterIcon: {
            marginRight: 2,
            width: '24px',
            height: '24px'
        },
        navFooterLink: {
            fontSize: 'sm',
            fontWeight: 'medium',
            lineHeight: '100%',
            letterSpacing: '0px',
            lineHeight: '0',
            paddingTop: '0.25em',
            paddingBottom: '0.5em',
            '@supports (-webkit-appearance: none) and (stroke-color: transparent)': {
                paddingTop: '0.6em',
                paddingBottom: '0.20em'
            }
        }
    },
    nestedCategory: {
        navTab: {
            flexDirection: 'row',
            justifyContent: 'flex-start',
            width: '100%',
            color: 'warmBlack',
            fontSize: 'md',
            fontWeight: 'medium',
            lineHeight: '24px',
            letterSpacing: '0px',
            backgroundColor: 'white',
            height: 'auto',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: 4,
            paddingRight: 4,
            _hover: {
                backgroundColor: 'white'
            },
            _focusVisible: {
                margin: '3px',
                boxShadow: 'var(--chakra-shadows-outline)'
            },
            '@supports (-webkit-appearance: none) and (stroke-color: transparent)': {
                paddingTop: '10px',
                paddingBottom: '10px'
            }
        },
        navName: {
            display: 'flex',
            alignItems: 'center',
            fontSize: 'md',
            fontWeight: 'medium',
            lineHeight: '24px',
            letterSpacing: '0px',
            color: 'warmBlack',
            flex: 1,
            textAlign: 'left',
            textTransform: 'capitalize',
        },
        navLink: {
            fontSize: 'md',
            fontWeight: 'medium',
            lineHeight: '18px',
            letterSpacing: '0px',
            color: 'warmBlack',
            flex: 1,
            textAlign: 'left',
            textTransform: 'capitalize',
            textDecoration: 'none',
            _hover: {
                textDecoration: 'none'
            },
            _active: {
                textDecoration: 'none'
            },
            _focusVisible: {
                margin: '3px',
                boxShadow: 'var(--chakra-shadows-outline)'
            }
        },
        arrowIcon: {
            transform: 'rotate(270deg)',
            width: '14px',
            height: '14px'
        },
        badge: {
            fontSize: '10px',
            fontWeight: 'medium',
            marginLeft: 1,
            lineHeight: '100%',
            padding: 1,
            border: '1px solid',
            borderColor: 'black',
            height: 'max-content'
        }
    },
    parts: []
}
